/*JB < />*/
import { Box, Text } from '@chakra-ui/react';
import { getSteps } from './utils';

const ProgressBar = ({isMultipart, stepIndex, groupedQuestions,section}) => {
  let [currentStep, steps, qObj] = getSteps(stepIndex, groupedQuestions);
  // assumes there are only 4 steps - may be only temporary fix
  let maxWidth = section === 'professional-experience' ? '1000px' : '800px';
  maxWidth = section.includes('interview') ? '100%' : maxWidth;
  const sxe = {width: '100%', maxWidth: maxWidth};
  if(section === 'interview-sparl') {
    steps--;
  }
  let questionText = 'Question ' + currentStep + ' of ' + steps;

  const isBulletBank =
    qObj &&
    typeof qObj['question_type'] !== 'undefined' &&
    qObj['question_type'] === 'bullets'
      ? true
      : false;
  if (!isBulletBank && !isMultipart && groupedQuestions.length > 1) {
    return (
      <Box className="progressBar"
           sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box sx={sxe}>
          <Text variant="o14" textAlign='left'>
            {questionText}
          </Text>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};

export default ProgressBar;
